export default {"src":"/_next/static/media/mana7.2317378d.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};